export default __webpack_public_path__ + "static/media/JSON.8ae2f3b0.svg";